import React, { useEffect, useState } from "react";
import useWindowDimensions from "../../../hooks/useWindowDimension";
import { useSpring, animated } from "react-spring";
import { Icon, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import Logo from "../../Logo/Logo";
import {ROUTES} from "../../../config/site.config";

function Drawer(props) {
  const { handleDrawerClose, routes, accessoryBottom, showDrawer } = props;
  const { width } = useWindowDimensions();
  const [fullWidth, setFullWidth] = useState(width < 600 ? true : false);

  useEffect(() => {
    if (width < 600) {
      setFullWidth(true);
    } else {
      setFullWidth(false);
    }
  }, [width]);

  const styles = {
    container: {
      position: "absolute",
      top: 0,
      left: 0,
      width: showDrawer ? width : 0,
      height: "100vh",
      zIndex: 3,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    drawerHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexDirection: "column",
      width: "100%",
      height: "17%",
      backgroundColor: "#D3B925",
    },
  };

  const drawerMenu = useSpring({
    zIndex: 4,
    width: !showDrawer ? 0 : fullWidth ? width : width / 2,
    opacity: showDrawer ? 1 : 0,
    height: "100vh",
    backgroundColor: "white",
    config: { mass: 1, tension: 200, friction: 20, bounce: 0 },
  });

  return (
    <div style={styles.container}>
      <animated.div style={drawerMenu}>
        {showDrawer && (
          <>
            <div style={styles.drawerHeader}>
              <div
                style={{
                  width: "90%",
                  height: "30%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Icon
                  fontSize="large"
                  style={{ color: "white", cursor: "pointer" }}
                  onClick={() => handleDrawerClose()}
                >
                  close
                </Icon>
              </div>
              <div
                style={{
                  height: "40%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Link to={ROUTES.HOME_PATH} style={{ textDecoration: "none" }}>
                  <Logo type="white" />
                </Link>
              </div>
              <div style={{ height: "30%" }} />
            </div>
            {routes.map((route, key) => (
              <div
                key={key}
                style={{
                  width: "100%",
                  alignSelf: "center",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  borderBottom: "1px solid #e6e6e6",
                  paddingBottom: 10,
                  paddingTop: 10,
                }}
              >
                <Link
                  to={route.path}
                  style={{ textDecoration: "none", marginLeft: 10 }}
                >
                  <Typography variant="h6">{route.label}</Typography>
                </Link>
              </div>
            ))}
            <div
              style={{
                marginTop: 50,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {accessoryBottom && accessoryBottom}
            </div>
          </>
        )}
      </animated.div>
    </div>
  );
}

export default Drawer;
